import { formatISO, isValid } from 'date-fns';

export const parseToTimezoneString = (dateString: string): string => {
  if (!dateString?.trim()) return '';

  const dateObj = new Date(dateString.trim());

  if (!isValid(dateObj)) {
    console.warn(`Invalid date string provided: "${dateString}"`);
    return '';
  }

  return formatISO(dateObj);
};

export type DateDisplayStyle = 'short' | 'long' | 'time' | 'datetime' | 'weekday';

const DATE_STYLES: Record<DateDisplayStyle, Intl.DateTimeFormatOptions> = {
  short: { dateStyle: 'short' },
  long: { dateStyle: 'long' },
  time: {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  },
  datetime: {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  },
  weekday: { weekday: 'long' }
};

export const formatDateForDisplay = (
  dateString: string,
  style: DateDisplayStyle = 'short'
): string => {
  if (!dateString) return '-';

  const date = new Date(dateString);
  if (!isValid(date)) return '-';

  const options = DATE_STYLES[style];
  return date.toLocaleString('pt-BR', options);
};